<template>
    <CardPage :section="20" :page="8" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Congrats on working your way through the House of LifeSkills! You will always be part of our house, and you can always return to revisit any of the
            sessions if you need a refresher. I’m so proud of you and all you’ve accomplished. To me, you are already an icon!
        </p>
        <ResponsiveImage
            :src="require('@/assets/poses/Trans-Poses_0003_Queenie_talking.png')"
            alt="Queenie"
            layout="align-center justify-end mt-3"
            flex="xs4"
        ></ResponsiveImage>
    </CardPage>
</template>

<script>
export default {
    methods: {
        finish() {
            this.$store.set('section20/complete', true);
        }
    }
};
</script>
